import React, { useEffect } from 'react';
import LogCannon from '@ace-clublabs/log-cannon';
import { Route, Switch, useLocation } from 'react-router';
import { STATE_KEY, useGlobalState } from '../state/state';
import { IState } from '../state/model';
import { Pages } from '../utils/constants';
import { Confirmation, LandingPage, MembershipCard, SelectMember } from '../containers';
import { SorryPage } from '../containers/SorryPage';
import { RequestPlasticCard } from '../containers/RequestPlasticCard';
import { MaintenancePage } from '../containers/MaintenancePage';

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    LogCannon.blast(`Navigate to ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
    });

    window.scrollTo(0, 0);
  }, [location]);
}

const Router: React.FC = () => {
  usePageViews();

  const state: Partial<IState> = {
    //memberDetails: useGlobalState('memberDetails')[0],
    //confirmation: useGlobalState('confirmation')[0],
    tags: useGlobalState('tags')[0],
    isMobileApp: useGlobalState('isMobileApp')[0],
  };

  useEffect(() => {
    sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
  }, [state]);

  return (
    <Switch>
      <Route path={Pages.SelectMemberPage} component={SelectMember} />
      <Route path={Pages.MembershipCard} component={MembershipCard} />
      <Route path={Pages.RequestPlasticCard} component={RequestPlasticCard} />
      <Route path={Pages.Confirmation} component={Confirmation} />
      <Route path={Pages.MantenancePage} component={MaintenancePage} />
      <Route exact path={Pages.TimeoutError} component={() => <SorryPage errorType="timeout" />} />
      <Route exact path={Pages.SorryPage} component={SorryPage} />
    </Switch>
  );
};

export default Router;
